import { NgModule } from '@angular/core';
import { HeaderModule } from '../core/navigation/header/header.module';
import { LeftNavModule } from '../../frontend/core/navigation/left-nav/left-nav.module';

import { InfoPagesComponent } from './info-pages.component';
import { infoPagesRouter } from './info-pages.router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ InfoPagesComponent ],
  imports: [
    CommonModule,
    infoPagesRouter,
    HeaderModule,
    LeftNavModule
  ],
  exports: [ InfoPagesComponent ]
})

export class InfoPagesModule {}
